{
	"404": {
		"siteNotFound": "Site not found"
	},
	"accept": "Close",
	"allow-location-text": "To see the closest post office, parcel locker or parcel point you need to share your location",
	"allow-location": "Show location",
	"article": {
		"no-blog-found": "No blog found",
		"no-news-found": "No news found",
		"something-went-wrong": "Something went wrong, couldn't fetch data."
	},
	"bubble": {
		"chat": "Online chat",
		"email": "Send us an email",
		"help": "How can we help?",
		"tips": "Customer feedback"
	},
	"captchaValid": "Not valid, try again",
	"choose-month": "Choose month",
	"choose-year": "Choose year",
	"company": "Business",
	"dimension": "Select the shipment dimensions",
	"dimension-text": "If the package is larger than 20x30x50 cm we will measure its volume before shipment. Please enter the measurement for your package below to get the correct price.",
	"width-cm": "Width (cm)",
	"height-cm": "Height (cm)",
	"length-cm": "Length (cm)",
	"width": "Width",
	"height": "Height",
	"length": "Length",
	"refresh": "Refresh",
	"error": {
		"error-countries": "Couldn't fetch countries",
		"error-heading": "Something went wrong",
		"error-postbox": "Couldn't fetch postboxes",
		"error-parcelpoint": "Couldn't fetch parcel points",
		"error-subtext": "There was an error, we're looking into it",
		"error-postoffice": "Couldn't fetch post offices",
		"error-500-unknown": "Something went wrong",
		"error-try-refresh": "Try refreshing the page"
	},
	"footer": {
		"follow-us-on-social-media": "Follow us on social media",
		"jlv-cert": "Equal pay certification",
		"bsi-cert": "ISO 9001 certification",
		"vog-2021": "Jafnvægisvog 2021"
	},
	"header": {
		"close": "Close",
		"find-shipment": "Track shipment",
		"minn-postur": "My account",
		"register-shipment": "Register shipment",
		"search": "Search",
		"search-path": "/en/search"
	},
	"individual": "Individual",
	"invoice": {
		"send-invoice": "Send invoice"
	},
	"mainPhone": "Telephone",
	"misc": {
		"24/7": "All day",
		"email": "Email",
		"map-unavailable": "Map unavailable right now. Please use the location details or try again later.",
		"opening-hours": "Opening hours",
		"questions-and-answers": "Q&A",
		"see-on-map": "See on map",
		"telephone": "Telephone"
	},
	"more": "More",
	"name": "Name",
	"price-wihtout-importduty": "Price without import duty tax",
	"description": "Description",
	"post-box": {
		"post-box": "Parcel locker",
		"post-box-near-you": "Parcel locker near you",
		"post-box_lowercase": "parcel locker",
		"see-all": "See all parcel lockers",
		"see-all-post-boxes": "See all parcel lockers",
		"text": "View all parcel lockers available"
	},
	"parcel-point": {
		"parcel-point": "Parcel point",
		"parcel-point-near-you": "Parcel points near you",
		"see-all-parcel-points": "See all parcel points"
	},
	"opening-hours": {
		"opening-hours": "Opening hours",
		"see-all": "Show all",
		"text": "View opening hours and locations for post offices and pacel lockers"
	},
	"post-code": {
		"search-by-post-code": "Search by post code"
	},
	"post-office": {
		"find-post-office": "Find post office",
		"post-office": "Post office",
		"post-office-or-post-box": "Post office or parcel locker",
		"post-office_lowercase": "post office",
		"post-offices-near-you": "Post offices near you",
		"see-all-post-offices": "See all post offices"
	},
	"price": "Price",
	"price-from": "Price from",
	"price-estimated": "Estimated price",
	"see-more": "See more",
	"services": {
		"order-home-delivery": "Order home delivery"
	},
	"shipment": {
		"enter-a-shipment-number": "Enter a tracking number",
		"find-shipment": "Track shipment",
		"register-shipment": "Register shipment",
		"register-shipment-info": "Register your shipment before going to the post office",
		"search-for-shipment": "Search",
		"send-receipt": "Send receipt"
	},
	"success-failure": {
		"open-pdf": "If the PDF doesn't open automatically you can use the link below.",
		"open-pdf-link": "Open PDF",
		"print-pdf": "Print out the PDF and have it with you when you go to the post office.",
		"success": "Success",
		"thereWasAnError": "This operation was not successfull",
		"thereWasAnErrorText": "We have contacted an administrator. If this is urgent you can contact customer service."
	},
	"calculator": "Calculate the price for international deliveries",
	"applyForJob": "Apply",
	"fullTime": "Full time",
	"summerJobs": "Summer jobs",
	"theApp": "The App",
	"show": "Show",
	"hide": "Hide"
}
